import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, FileTextIcon, BuildingIcon } from 'lucide-react';
export const BonusesSection = () => {
  const bonuses = [{
    icon: <BookOpenIcon size={36} data-id="element-134" />,
    title: 'EBOOK – 100K EN 30 DÍAS',
    description: 'La única guía que necesitas para conseguir tus primeros $100K en crédito comercial a 0% de interés.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/khSY533Tpcidpmrn6EzZQn/IG_Post.jpg'
  }, {
    icon: <FileTextIcon size={36} data-id="element-135" />,
    title: 'MIS TOP 20 TEMPLATES',
    description: '20 poderosas plantillas personalizadas que te permitirán optimizar tu perfil de crédito de forma profesional.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/xgTxGgbMXNNTSkP9z5D78u/shutterstock_1239162877-1.jpg'
  }, {
    icon: <BuildingIcon size={36} data-id="element-136" />,
    title: 'MI LISTA SECRETA DE BANCOS Y PRIVATE LENDERS',
    description: 'Crea relación con los mejores bancos y private lenders de Estados Unidos.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/tX8Dt9doP93MnZ1UTwNfP3/images_%281%29.jpg'
  }];
  return <section className="w-full py-8 sm:py-12 px-4 bg-gray-50" data-id="element-137">
      <div className="container mx-auto max-w-6xl" data-id="element-138">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-6 sm:mb-10" data-id="element-139">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-black mb-3" data-id="element-140">
            Recursos Gratis Incluidos
          </h2>
          <div className="h-1 w-20 bg-[#7A3EFF] mx-auto rounded-full" data-id="element-141" />
        </motion.div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 sm:gap-6" data-id="element-142">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} className="bg-white rounded-2xl overflow-hidden border-2 border-[#7A3EFF] shadow-lg" data-id="element-143">
              {/* Image */}
              <div className="relative h-44 overflow-hidden" data-id="element-144">
                <img src={bonus.image} alt={bonus.title} className="w-full h-full object-cover" data-id="element-145" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" data-id="element-146" />
                <div className="absolute bottom-3 left-3 text-white" data-id="element-147">
                  {bonus.icon}
                </div>
              </div>
              {/* Content */}
              <div className="p-5" data-id="element-148">
                <h3 className="text-xl sm:text-2xl font-bold text-black mb-2 leading-tight" data-id="element-149">
                  {bonus.title}
                </h3>
                <p className="text-gray-700 leading-relaxed text-sm sm:text-base" data-id="element-150">
                  {bonus.description}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
};